import axios from 'axios';
import cookie from '../cookieHelper/cookie'; 

const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/user`;

export default function getUserList() {
    
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return (
        axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log('users: ', res.data.data);
            return res.data.data;
        })
        .catch(err => {
            // console.error('Error fetching user list: ', err);
            return err;
        })
    );
}
